
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"100"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"#717171","d":"M38.588 73.287V26.714L73.518 50z"}}),_c('path',{attrs:{"fill":"#717171","d":"M50 8.334A41.712 41.712 0 0191.666 50 41.712 41.712 0 0150 91.666 41.712 41.712 0 018.334 50 41.712 41.712 0 0150 8.334zM50 0A50 50 0 000 50a50 50 0 0050 50 50 50 0 0050-50A50 50 0 0050 0z"}})])
          )
        }
      }
    